module.exports = __webpack_public_path__ + "static/media/findarticle.aac5a561.png";